<template>
    <div class="min-h-screen flex flex-col justify-center p-8" style="background-color: rgb(249 251 253);">

        <div class="flex-1 flex flex-col justify-center">
            <div class="text-xl mb-2">{{ statusCode }}</div>
            <h1 class="text-[32px] font-extrabold mb-6">{{ errorMessage }}</h1>

            <hr class="w-1/3 mb-4">

            <div v-if="statusCode === 403">
                <div class="text-sm mb-2">You don't have permission to access this organization.</div>
            </div>
            <div v-else-if="statusCode === 404">
                <div class="text-sm mb-2">The page you are looking for does not exist.</div>
            </div>
            <div v-else-if="statusCode === 500">
                <div class="text-sm mb-2">There was an error processing your request. Please try again later.</div>
            </div>
            <div v-else>
                <div class="text-sm mb-2">{{ customMessage || 'An error occurred' }}</div>
            </div>
            <div class="text-sm my-2">If you think there is an error please contact support.</div>

            <div class="mt-8 space-x-4">
                <Button type="secondary" button-type="button" @click="openMailto">
                    <svg class="svg-inline--fa fa-envelope" aria-hidden="true" focusable="false" data-prefix="far" data-icon="envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
                        <path fill="currentColor" d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"></path>
                    </svg>
                    <span class="ml-1">Contact Support</span>
                </Button>
            </div>
        </div>

        <div>
            <a :href="`${config.public.boardDomain}/accounts`"><img src="/img/boardable_logo_dark.svg" class="h-6" alt="Boardable Logo"></a>
        </div>
    </div>

</template>

<script setup>
import Button from "~/components/ui/Button.vue";

// No layout for this page
definePageMeta({
    layout: false
});

const config = useRuntimeConfig();
const route = useRoute();

const openMailto = () => {
    if (typeof window !== 'undefined') {
        window.location.href = 'mailto:support@boardable.com';
    }
};

// Get error details from query params
const statusCode = ref(route.query.code || '404');
const customMessage = ref(route.query.message || '');

const errorMessage = computed(() => {
    const messages = {
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Page Not Found',
        500: 'Internal Server Error',
        502: 'Bad Gateway',
        503: 'Service Unavailable'
    };
    
    return messages[statusCode.value] || customMessage.value || 'An error occurred';
});
</script>